<mat-card data-at-installations-migration-modal-installations>
  <mat-card-title data-at-installations-migration-modal-header>{{
    '+INSTALLATIONS_MIGRATION.HEADER' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col">
    <div
      class="customer-numbers-container flex flex-row lt-md:flex-col lt-md:gap-[12px] justify-around items-center"
    >
      <div
        class="customer-number flex flex-col justify-start items-stretch lt-md:items-center flex-[40%] max-w-[40%] lt-md:flex-[100%] lt-md:max-w-[100%]"
      >
        <span class="customer-number-label">{{
          '+MIGRATION.INPUT.CUSTOMER_NUMBER' | translate
        }}</span>
        {{ installationsMigrationStore.customerNumber$ | async }}
        <span>{{ installationsMigrationStore.customerCompanyName$ | async }}</span>
      </div>
      <div
        class="customer-number flex flex-col justify-start items-stretch lt-md:items-center flex-[40%] max-w-[40%] lt-md:flex-[100%] lt-md:max-w-[100%]"
      >
        <span class="customer-number-label">{{
          '+MIGRATION.INPUT.CUSTOMER_NUMBER_NEW' | translate
        }}</span>
        {{ installationsMigrationStore.newCustomerNumber$ | async }}
        <span>{{ installationsMigrationStore.newCustomerCompanyName$ | async }}</span>
      </div>
    </div>

    <div data-at-installations-migration-description class="migration__description">
      {{ '+INSTALLATIONS_MIGRATION.SELECT_DEVICES_TO_TRANSFER' | translate }}
    </div>

    <div *ngIf="installationsMigrationStore.state$ | async as state" class="flex flex-col">
      <div class="migration__table-header lt-md:!hidden flex flex-row">
        <div class="flex-[10%] max-w-[10%]">
          <mat-checkbox
            data-at-installations-migration-table-header-checkbox
            class="migration__checkbox flex flex-row justify-center items-center"
            [class.migration__checkbox--disabled]="!state.isData"
            [checked]="isAllCheckboxChecked"
            [disabled]="!state.isData"
            (change)="onToggleAll()"
            color="primary"
            gtm="onSelect"
            gtmAction="All installations to migrate"
            gtmCategory="migrateInstallation"
          ></mat-checkbox>
        </div>
        <div class="flex-[30%] max-w-[30%]">
          <span data-at-installations-migration-table-header-name>{{
            '+INSTALLATIONS_MIGRATION.TABLE.DEVICE_NAME' | translate
          }}</span>
        </div>
        <div class="flex-[20%] max-w-[20%]">
          <span data-at-installations-migration-table-header-gateway>{{
            '+INSTALLATIONS_MIGRATION.TABLE.GATEWAY_SERIAL' | translate
          }}</span>
        </div>
        <div class="flex-[5%] max-w-[5%]"></div>
        <div class="flex-[35%] max-w-[35%]">
          <span data-at-installations-migration-table-header-address>{{
            '+INSTALLATIONS_MIGRATION.TABLE.ADDRESS' | translate
          }}</span>
        </div>
      </div>

      <div class="migration__table-header gt-sm:!hidden flex flex-row">
        <div class="flex-[20%] max-w-[20%]">
          <mat-checkbox
            data-at-installations-migration-table-header-checkbox
            class="migration__checkbox flex flex-row justify-center items-center"
            [class.migration__checkbox--disabled]="!state.isData"
            [checked]="isAllCheckboxChecked"
            [disabled]="!state.isData"
            (change)="onToggleAll()"
            color="primary"
            gtm="onSelect"
            gtmAction="All installations to migrate"
            gtmCategory="migrateInstallation"
          ></mat-checkbox>
        </div>
        <div class="flex flex-row justify-center items-center flex-[80%] max-w-[80%]">
          <span data-at-installations-migration-table-header-all
            >{{ '+INSTALLATIONS_MIGRATION.TABLE.DEVICE_NAME' | translate }}/{{
              '+INSTALLATIONS_MIGRATION.TABLE.OWNER' | translate
            }}/{{ '+INSTALLATIONS_MIGRATION.TABLE.ADDRESS' | translate }}</span
          >
        </div>
      </div>

      <ng-container *ngIf="state.isData && state.loaded">
        <app-infinite-scroll
          [state$]="installationsMigrationStore.state$"
          [search$]="searchType$"
          [itemSize]="getRowHeight()"
          [limit]="batchSize"
          [(nextBatch)]="nextBatch"
          (nextBatchChange)="onNextBatchChange($event)"
          (fetchNext)="onFetchNext()"
        >
          <cdk-virtual-scroll-viewport
            class="migration__infinite-scroll"
            [itemSize]="getRowHeight()"
          >
            <div
              data-at-installations-migration-table
              *cdkVirtualFor="let installation of state.installations"
              class="migration__table-row flex flex-row flex-wrap"
            >
              <div
                class="gt-sm:!hidden flex flex-row justify-center items-center flex-[20%] max-w-[20%]"
              >
                <mat-checkbox
                  data-at-installations-migration-table-row-checkbox
                  class="migration__checkbox"
                  color="primary"
                  [checked]="isChecked(installation.id)"
                  (click)="onToggleSingle(installation.id)"
                  gtm="onSelect"
                  gtmAction="An installations to migrate"
                  gtmCategory="migrateInstallation"
                >
                </mat-checkbox>
              </div>

              <div
                class="flex flex-row lt-md:flex-col justify-start items-center flex-[100%] max-w-[100%] lt-md:flex-[80%] lt-md:max-w-[80%]"
              >
                <div
                  class="lt-md:!hidden flex flex-row justify-center items-center flex-[10%] max-w-[10%]"
                >
                  <mat-checkbox
                    data-at-installations-migration-table-row-checkbox
                    class="migration__checkbox"
                    color="primary"
                    [checked]="isChecked(installation.id)"
                    (click)="onToggleSingle(installation.id)"
                    gtm="onSelect"
                    gtmAction="An installations to migrate"
                    gtmCategory="migrateInstallation"
                  >
                  </mat-checkbox>
                </div>
                <div
                  class="flex flex-row justify-start items-stretch lt-md:items-center flex-[30%] max-w-[30%] lt-md:flex-[100%] lt-md:max-w-[100%]"
                >
                  <span data-at-installations-migration-table-row-description>{{
                    getMainDeviceWithMarketingName(installation?.gateways)?.marketingName | dash
                  }}</span>
                </div>
                <div
                  class="flex flex-row justify-start items-stretch lt-md:items-center flex-[20%] max-w-[20%] lt-md:flex-[100%] lt-md:max-w-[100%]"
                >
                  <span data-at-installations-migration-table-row-gateway>{{
                    getInstallationGateway(installation?.gateways) | dash
                  }}</span>
                </div>
                <div class="flex-[5%] max-w-[5%]"></div>
                <div
                  class="flex flex-row justify-start items-stretch lt-md:items-center flex-[35%] max-w-[35%] lt-md:flex-[100%] lt-md:max-w-[100%]"
                >
                  <span data-at-installations-migration-table-row-address>
                    {{ installation?.location }}
                  </span>
                </div>
              </div>
            </div>

            <vi-loader
              *ngIf="nextBatch"
              [isLoading]="true"
              message="{{ 'GATEWAY.INVITATION_LIST.LOADING_MORE' | translate }}"
            ></vi-loader>
          </cdk-virtual-scroll-viewport>
        </app-infinite-scroll>
      </ng-container>

      <ng-container *ngIf="!state.isData && state.loaded">
        <div data-at-installations-migration-table-no-results class="no-results">
          {{ '+INSTALLATIONS_MIGRATION.NO_RESULTS' | translate }}
        </div>
      </ng-container>
    </div>

    <div class="migration__selected-installations-hint">
      {{ '+INSTALLATIONS_MIGRATION.SELECTED_INSTALLATIONS_INFO' | translate }}:
      {{
        !isAllCheckboxChecked
          ? checkedInstallations.length
          : ('+INSTALLATIONS_MIGRATION.ALL_INSTALLATIONS' | translate)
      }}
    </div>
  </mat-card-content>
  <mat-card-actions class="mat-card-actions">
    <!-- desktop view    -->
    <div class="lt-md:!hidden flex flex-row gap-[8px] justify-between items-center">
      <button
        data-at-installations-migration-btn-back
        class="lt-md:flex-[20%] lt-md:max-w-[20%]"
        mat-button
        color="primary"
        (click)="onBack()"
        gtm="onBackDialog"
        gtmAction="To 1st step"
        gtmCategory="migrateInstallation"
      >
        {{ 'GENERAL.BUTTON.BACK' | translate }}
      </button>
      <div class="flex flex-row gap-[8px]">
        <button
          data-at-installations-migration-btn-cancel
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onClose()"
          gtm="onCancel"
          gtmAction="Migrating installations"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>

        <button
          data-at-installations-migration-btn-migrate-selected
          [disabled]="!canMigrateInstallations()"
          (click)="onMigrateInstallations()"
          mat-raised-button
          color="primary"
          gtm="onNextStep"
          gtmAction="Migrate selected installations"
          gtmCategory="migrateInstallation"
        >
          {{ '+INSTALLATIONS_MIGRATION.BTN.MIGRATE_SELECTED' | translate }}
        </button>
      </div>
    </div>

    <!-- mobile view -->
    <div class="flex flex-col gap-[8px] gt-sm:!hidden justify-between items-center">
      <div class="flex flex-row gap-[8px]">
        <button
          data-at-installations-migration-btn-back
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onBack()"
          gtm="onBackDialog"
          gtmAction="To 1st step"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.BACK' | translate }}
        </button>
        <button
          data-at-installations-migration-btn-cancel
          class="lt-md:flex-[20%] lt-md:max-w-[20%]"
          mat-button
          color="primary"
          (click)="onClose()"
          gtm="onCancel"
          gtmAction="Migrating installations"
          gtmCategory="migrateInstallation"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>
      </div>

      <button
        data-at-installations-migration-btn-migrate-selected
        [disabled]="!canMigrateInstallations()"
        (click)="onMigrateInstallations()"
        mat-raised-button
        color="primary"
        gtm="onNextStep"
        gtmAction="Migrate selected installations"
        gtmCategory="migrateInstallation"
      >
        {{ '+INSTALLATIONS_MIGRATION.BTN.MIGRATE_SELECTED' | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
